/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useEffect, useState } from "react";
import Author from "components/Table/Author";
import MDBox from "components/MDBox";
import { IconButton } from "@mui/material";
import { Icons, defaultData } from "utils/Constants";
import moment from "moment";

export const policyStatusStyles = {
  Active: { backgroundColor: "#DBF4DB", color: "#28873C" },
  Pending: { backgroundColor: "#FEF5CD", color: "#DA850A" },
  Renewed: { backgroundColor: "#E1EFFE", color: "#1656E1" },
  Expired: { backgroundColor: "#FEE4E2", color: "#D92D20" },
  Cancelled: { backgroundColor: "#FEE4E2", color: "#D92D20" },
  default: { backgroundColor: "#F2F4F7", color: "#344054" },
};

const renderPolicyStatus = (status) => {
  const statusStyle = policyStatusStyles[status] || policyStatusStyles.default;

  return (
    <MDBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        minHeight: 24,
        maxWidth: 180,
        px: 1.25,
        py: 0.25,
        borderRadius: "6px",
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: "normal",
        ...statusStyle,
      }}
    >
      {status || "-"}
    </MDBox>
  );
};

const formatDateValue = (date) => {
  if (!date) return "-";
  return moment(date).format(defaultData.WEB_DATE_FORMAT || "DD-MM-YYYY");
};

export default function insuranceTableData(
  insuranceData = [],
  handleViewModal,
  handleEditModal,
  handleDelete,
  handleViewAttachments
) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (insuranceData) {
      const list = insuranceData.map((item, index) => {
        const docCount = Array.isArray(item?.attachments) ? item.attachments.length : 0;

        return {
          srNo: <Author name={index + 1} />,
          month: <Author name={item.month} />,
          inquiryDate: <Author name={formatDateValue(item.inquiryDate)} />,
          policyIssueDate: <Author name={formatDateValue(item.policyIssueDate)} />,
          customerName: <Author name={item.customerName || "-"} />,
          mobileNumber: <Author name={item.mobileNumber || "-"} />,
          email: <Author name={item.email || "-"} style={{ textTransform: "normal" }} />,
          product: <Author name={item.product || "-"} />,
          grossPremium: (
            <Author
              name={
                item.grossPremium !== undefined &&
                item.grossPremium !== null &&
                item.grossPremium !== ""
                  ? Number(item.grossPremium.toString().replace(/,/g, "")).toLocaleString("en-IN")
                  : ""
              }
              align="right"
              style={{ textAlign: "right" }}
            />
          ),
          netPremium: (
            <Author
              name={
                item.netPremium !== undefined && item.netPremium !== null && item.netPremium !== ""
                  ? Number(item.netPremium.toString().replace(/,/g, "")).toLocaleString("en-IN")
                  : ""
              }
              align="right"
              style={{ textAlign: "right" }}
            />
          ),
          policyStatus: renderPolicyStatus(item?.policyStatus),
          planName: <Author name={item.planName || "-"} />,
          policyNumber: <Author name={item.policyNumber || "-"} />,
          renewalDate: <Author name={formatDateValue(item.renewalDate)} />,
          insuranceCompany: <Author name={item.insuranceCompany || "-"} />,
          code: <Author name={item.code || "-"} />,
          imd: <Author name={item.imd || "-"} />,
          reference: <Author name={item.reference || "-"} />,
          attachments: (
            <MDBox>
              {docCount > 0 ? (
                <IconButton
                  fontSize="medium"
                  sx={{ cursor: "pointer", color: "#475467" }}
                  onClick={() => handleViewAttachments && handleViewAttachments(item)}
                >
                  {Icons.VIEW}
                </IconButton>
              ) : (
                <Author name="-" />
              )}
            </MDBox>
          ),
          action: (
            <MDBox>
              <IconButton
                fontSize="medium"
                sx={{ cursor: "pointer", color: "#475467" }}
                onClick={() => handleViewModal && handleViewModal(item)}
              >
                {Icons.VIEW}
              </IconButton>
              <IconButton
                fontSize="medium"
                sx={{ cursor: "pointer", color: "#475467" }}
                onClick={() => handleEditModal && handleEditModal(item)}
              >
                {Icons.EDIT2}
              </IconButton>
              <IconButton
                fontSize="medium"
                sx={{ cursor: "pointer", color: "#475467" }}
                onClick={() => handleDelete && handleDelete(item)}
              >
                {Icons.DELETE}
              </IconButton>
            </MDBox>
          ),
        };
      });
      setRows(list);
    }
  }, [insuranceData]);

  return {
    columns: [
      { Header: "No.", accessor: "srNo", width: "4%" },
      { Header: "Month", accessor: "month", width: "7%" },
      { Header: "Inquiry Date", accessor: "inquiryDate", width: "9%" },
      { Header: "Policy Issue Date", accessor: "policyIssueDate", width: "9%" },
      { Header: "Name", accessor: "customerName", width: "12%" },
      { Header: "Mobile Number", accessor: "mobileNumber", width: "10%" },
      { Header: "Email", accessor: "email", width: "12%" },
      { Header: "Product", accessor: "product", width: "10%" },
      { Header: "Gross Premium", accessor: "grossPremium", width: "9%", align: "right" },
      { Header: "Net Premium", accessor: "netPremium", width: "9%", align: "right" },
      { Header: "Status", accessor: "policyStatus", width: "10%" },
      { Header: "Name of Plan", accessor: "planName", width: "10%" },
      { Header: "Policy Number", accessor: "policyNumber", width: "11%" },
      { Header: "Renewal Date", accessor: "renewalDate", width: "9%" },
      { Header: "Insurance Company", accessor: "insuranceCompany", width: "11%" },
      { Header: "Code", accessor: "code", width: "8%" },
      { Header: "IMD", accessor: "imd", width: "8%" },
      { Header: "Reference", accessor: "reference", width: "8%" },
      { Header: "Attachments", accessor: "attachments", width: "8%" },
      { Header: "Action", accessor: "action", width: "8%" },
    ],
    rows,
  };
}
